const colors = {
  primary: "#c14481",
  text: "#333333"
};
export default colors;
